import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useUncollectableCustomerPayments } from "@/lib/stripe/customer-payments";
import useViewerRole from "@/lib/rights/use-viewer-role";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@babackapp/ui/components/alert";
import { Button } from "@babackapp/ui/components/button";
import { CreditCard } from "lucide-react";
import { Link } from "react-router-dom";

// BBS-386: settings that let customers pay, without the Stripe account that
// collects those payments. The portal refuses them at the payment step.
export default function StripeMissingBanner() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const viewerRole = useViewerRole();
  // Connecting Stripe needs the integrations settings, which other roles lack.
  const isOwnerOrAdmin = viewerRole === "owner" || viewerRole === "admin";
  const uncollectablePayments = useUncollectableCustomerPayments({
    canReadOverrideRules: isOwnerOrAdmin,
  });

  if (!isOwnerOrAdmin || uncollectablePayments.length === 0) return null;

  return (
    <Alert variant="warning" className="col-span-4">
      <CreditCard className="size-4" />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <AlertTitle>{t("home.stripeMissingBanner.heading")}</AlertTitle>
          <AlertDescription>
            {t("home.stripeMissingBanner.message")}
          </AlertDescription>
        </div>
        <Button asChild size="sm" className="w-fit shrink-0">
          <Link to={`/shops/${shop.id}/settings/integrations/stripe`}>
            {t("home.stripeMissingBanner.button")}
          </Link>
        </Button>
      </div>
    </Alert>
  );
}
